<template>
<!-- 行程样式 -->
  <div
    id="schedulePic"
    class="schedulePic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  >
    <div  class="title">{{tbInfo.name}}</div>
    <div  class="tbInfo">
       <div class="tbInfo-schedule">
          <el-table :data="tbInfo.tbInfoScheduleList" style="width: 100%" border :header-cell-style="{color: '#ffffff',
          fontSize: '18px', fontWeight: 700, backgroundColor: '#247F9C'}">
            <el-table-column prop="scheduleTime" label="开始时间" width="140" align="center"/>
            <el-table-column prop="name" label="行程环节" width="140" align="center"/>
            <el-table-column prop="decription" label="详情" align="center"/>
          </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "schedulePic",
  data() {
    return {
      loading: false
    };
  },
  props: ["backgroundPic","tbInfo"],
  methods: {

  },
  computed: {
    webInfo() {
      return this.$store.state.webInfo.configImgs;
    }
  },
  mounted() {
    
  }
};
</script>

<style scoped>
.schedulePic {
  width: 100%;
  height: 100%;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.schedulePic  >>> .el-table--border, .el-table--group,
.schedulePic  >>> .el-table--border th,
.schedulePic  >>> .el-table--border td  {
  border: 1px solid #19708c;
}
.title{
  font-size: 40px;
  font-weight: 700;
  margin-top: 50px;
}
.tbInfo{
  width: 80%;
}
.tbInfo-schedule{
  margin-top: 30px;
}
.header-title{
  background: #247F9C;font-weight: 700;
  color: #fff;
  font-weight: 700;
  text-align: center;
}
.tbInfo-schedule >>> .el-table__row .cell{
  color: #000;
}
/* .tbInfo-schedule >>>  */
</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/schedulePic.vue